import Model from "../../Model.js";

/**
 * `DocumentNotificationSetting` defines a set of settings for a notification.
 *
 * @param {string} spec.notificationSubject - The subject of the notification.
 * @param {string} spec.notificationBody - The body content of the notification, which contains html.
 */
export default class DocumentNotificationSetting extends Model {
	constructor({ notificationSubject = "", notificationBody = "" } = {}) {
		super(...arguments);

		this._notificationSubject = notificationSubject;
		this._notificationBody = notificationBody;

		this._companyUsers = [];
		this._agencyUsers = [];
	}

	setNotificationSubject(subject) {
		this._notificationSubject = subject;
	}

	getNotificationSubject() {
		return this._notificationSubject;
	}

	setNotificationBody(body) {
		this._notificationBody = body;
	}

	getNotificationBody() {
		return this._notificationBody;
	}

	setNotificationUsers({ companyUsers, agencyUsers }) {
		this._companyUsers = companyUsers;
		this._agencyUsers = agencyUsers;
	}

	getCompanyUsers() {
		return this._companyUsers;
	}

	getAgencyUsers() {
		return this._agencyUsers;
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.notificationSubject = this._notificationSubject;
		properties.notificationBody = this._notificationBody;

		return properties;
	}
}
